export const FIELDS = {
    CAMPAIGN_MANAGEMENT: 'campaignManagement'
}

export const initialFormValues = {
    [FIELDS.CAMPAIGN_MANAGEMENT]: false,
}